import { AUTHORIZATION_HEADER } from '../../../src/authorization';
import { send } from '../../../src/network';
import { type CustomerExperimentValue } from '../../../src/types/CustomerExperimentValue';
import { type SpicyValues } from '../../../src/types/SpicyEnum';

// If customer is on hold, on_hold_until_date will return a date string reflecting the next delivery date
export type CustomerV1 = {
  credit: number;
  day_of_week: number;
  default_cutoff_dow: number;
  did_checkout: boolean;
  email: string;
  first_name: string | null;
  id: number;
  is_on_hold: boolean | null;
  is_on_hold_next_week: boolean | null;
  is_vip: boolean;
  last_name: string | null;
  next_delivery_after_hold: null;
  on_hold_until_date: string | null;
  plan: number | null;
  rollover_credits: number;
  rollover_credits_expiration: Date | null;
} & Partial<CustomerPricing>;

interface CustomerPricing {
  plan_points: number;
  price_per_credit: number;
}

export enum CustomerIncludes {
  Pricing = 'pricing',
  PricingConfig = 'pricing_config',
  All = 'all',
}

export interface ExperimentObj {
  experiment_id: number;
  variant: CustomerExperimentValue['variant'];
}

export interface CustomerWithExperiments extends CustomerV1 {
  experiments: ExperimentObj[];
}

export type CustomerIncludesAll = CustomerV1 &
  CustomerWithExperiments & {
    spicy_level: SpicyValues | null;
  };

export interface GetCustomerParams {
  includes?: CustomerIncludes[] | CustomerIncludes;
}

export async function getCustomer(params: GetCustomerParams) {
  const { includes } = params;
  const query = new URLSearchParams();
  if (includes !== undefined) {
    if (typeof includes === 'string') {
      query.set('includes', includes);
    } else {
      query.set('includes', includes.join(','));
    }
  }
  return send<{ customer: CustomerIncludesAll }>({
    method: 'GET',
    path: '/api/get_customer/',
    query,
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
